import { useMissionsTranslation } from '../../../../ui/hooks';
import React from 'react';
import { SelectMissionShiftStep } from '../components/SelectMissionShiftStep';
import { SelectPositionStep } from '../components/SelectPositionStep';
import { SelectShiftStep } from '../components/SelectShiftStep';
import { SelectVolunteersStep } from '../components/SelectVolunteersStep';
export const useShiftVolunteerManagementWizardSteps = () => {
    const { t } = useMissionsTranslation();
    const selectPositionStep = () => ({
        label: t('shiftVolunteerManagementWizard.titles.selectPosition'),
        render: (props) => React.createElement(SelectPositionStep, Object.assign({}, props)),
    });
    const selectVolunteersStep = () => ({
        label: t('shiftVolunteerManagementWizard.titles.selectVolunteers'),
        render: (props) => React.createElement(SelectVolunteersStep, Object.assign({}, props)),
    });
    const selectShiftStep = (stepProps = {}) => ({
        label: t('shiftVolunteerManagementWizard.titles.selectShift'),
        render: (props) => React.createElement(SelectShiftStep, Object.assign({}, props, stepProps)),
    });
    const selectMissionShiftStep = (stepProps = {}) => ({
        label: t('shiftVolunteerManagementWizard.titles.selectMissionAndShift'),
        render: (props) => React.createElement(SelectMissionShiftStep, Object.assign({}, props, stepProps)),
    });
    return { selectPositionStep, selectVolunteersStep, selectShiftStep, selectMissionShiftStep };
};
